module.exports = __webpack_public_path__ + "static/4_social_media-ceff1c329f9957fc8e0b33f297a26600.webp";